import { render, staticRenderFns } from "./MedicareExpiryDateInput.vue?vue&type=template&id=1c0fe06c&scoped=true"
import script from "./MedicareExpiryDateInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicareExpiryDateInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MedicareExpiryDateInput.vue?vue&type=style&index=0&id=1c0fe06c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fe06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0fe06c')) {
      api.createRecord('1c0fe06c', component.options)
    } else {
      api.reload('1c0fe06c', component.options)
    }
    module.hot.accept("./MedicareExpiryDateInput.vue?vue&type=template&id=1c0fe06c&scoped=true", function () {
      api.rerender('1c0fe06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/date-input/MedicareExpiryDateInput.vue"
export default component.exports